var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-p_content"},[_c('h1',{staticClass:"l-p_content__title"},[_c('router-link',{staticClass:"l-p_content__logo",attrs:{"to":"/"}})],1),_vm._v(" "),_c('div',{staticClass:"l-p_content__form"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }